// import mqtt from 'mqtt';
import { connect } from 'mqtt';

export default class MqttService {
  constructor({ serverUrl, port, msgHandler }) {
    this.client = null;
    this.serverUrl = serverUrl;
    this.port = port;
    this.msgHandler = msgHandler;
    this.clientSuccess = false
  }
  isConnected() {
    if (!this.client) {
      return false;
    }

    return this.client.connected;
  }
  connect(success) {
    // keepAliveInterval: 60, reconnect: true
    this.client = connect(this.serverUrl, { port: this.port });
    this.client.on('connect', () => {
      if(!this.clientSuccess) {
        this.clientSuccess = true
      } else {
        return
      }
      success && success()
      this.handleMsg();
    });
  }
  subscribe({topic}) {
    if (!this.client || !this.client.subscribe) {
      return
    }

    this.client.subscribe(topic, {qos: 2})
  }
  end({ force, options, callback }) {
    this.client.end(force, options, callback);
  }
  handleMsg() {
    this.client.on('message', (topic, message, packet) => {
      this.msgHandler({ topic, message, packet });
    });
  }
}
